import {Collection} from 'MWC';
import Model from '../models/business.m';

export default class extends Collection {
    static model = Model;
}
